import { createContext, useContext, ReactNode, JSX } from 'react';
import { useNavigate, NavigateFunction } from 'react-router-dom';

interface NavigationContextType {
  navigate: NavigateFunction;
}

export const NavigationContext = createContext<
  NavigationContextType | undefined
>(undefined);

export const useNavigation = (): NavigateFunction => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context.navigate;
};

export const ReactRouterNavigationProvider = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  const navigate = useNavigate();

  return (
    <NavigationContext.Provider value={{ navigate }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const MockNavigationProvider = ({
  children,
  navigate = () => {},
}: {
  children: ReactNode;
  navigate?: NavigateFunction;
}): JSX.Element => {
  return (
    <NavigationContext.Provider value={{ navigate }}>
      {children}
    </NavigationContext.Provider>
  );
};
